// components/ServerErrorOverlay.js
import React from "react";

const ServerError = ({ onRetry }) => {
  return (
    <div className="server-error-overlay">
      <div className="server-error-message">
        <img src="/assets/images/kidskart/logo1.gif" style={{width: "300px"}}/>
        <h2>Server Error - 502</h2>
        <p>Unable to connect to the server, Please try again later.</p>
        {/* {onRetry && <button onClick={onRetry}>Retry</button>} */}
      </div>
    </div>
  );
};

export default ServerError;
